"use client";

import * as React from "react";
import Link from "next/link";
import { Icon } from "@/components/ui/icon";

import { Container } from "@/app/_components/layout/container";
import { finalCta } from "@/lib/content/homepage";
import { trackEvent } from "@/lib/analytics/dataLayer";

export function FinalCTA() {
  return (
    <section
      aria-label="Jetzt starten"
      className="bg-clarus-dark text-clarus-yellow py-24 md:py-36"
    >
      <Container size="narrow">
        <div className="text-center">
          <h2 className="text-display-xl mx-auto max-w-3xl text-clarus-yellow">
            {finalCta.heading}
          </h2>
          <p className="text-subline mt-6 mx-auto max-w-2xl text-clarus-purple">
            {finalCta.subline}
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link
              href={finalCta.cta.href}
              onClick={() => trackEvent("cta_scan", { location: "final_cta" })}
              className="inline-flex h-14 items-center justify-center gap-2 rounded-pill border-[1.5px] border-clarus-yellow bg-clarus-yellow px-7 text-cta text-clarus-dark transition-colors hover:bg-clarus-yellow/85 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-clarus-purple focus-visible:ring-offset-2 focus-visible:ring-offset-clarus-dark"
            >
              {finalCta.cta.label}
              <Icon name="arrow_forward" className="text-[16px]" />
            </Link>
            <Link
              href={finalCta.secondaryCta.href}
              onClick={() => trackEvent("book_demo", { source: "final_cta" })}
              {...(finalCta.secondaryCta.href.startsWith("http")
                ? ({ target: "_blank", rel: "noopener noreferrer" } as const)
                : {})}
              className="inline-flex h-14 items-center justify-center rounded-pill border-[1.5px] border-clarus-yellow bg-clarus-dark px-7 text-cta text-clarus-yellow transition-colors hover:bg-clarus-yellow hover:text-clarus-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-clarus-purple focus-visible:ring-offset-2 focus-visible:ring-offset-clarus-dark"
            >
              {finalCta.secondaryCta.label}
            </Link>
          </div>
          <p className="text-annotation mt-7 hidden text-clarus-purple md:block">
            {finalCta.trustMarks}
          </p>
        </div>
      </Container>
    </section>
  );
}
